import { Injectable, Inject, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { KeycloakAuthService } from '../core/services/keycloak-auth.service';
import { ApiConfigService } from '../core/services/api-config.service';


@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private api: AxiosInstance;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private authService: KeycloakAuthService, private apiConfig: ApiConfigService) {
    this.api = axios.create({
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Add request interceptor to dynamically set baseURL and include OAuth token
    this.api.interceptors.request.use((config) => {
      // Dynamically construct baseURL on each request to get current tenantId
      if (isPlatformBrowser(this.platformId)) {
        const baseUrl = this.apiConfig.getApiBaseUrl();
        config.baseURL = `${baseUrl}`;
      }

      const token = this.authService.accessToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

    async getAllPermissions(): Promise<Array<string> | null> {
        try {
            const response = await this.api.get('/permissions');
            return response.data;
        } catch (error: any) {
            console.error(error);
            throw error;
        }
    }
}
    
